const defaultState = {
  appName: 'Sedicii'
}

export default (state = defaultState, action) => {
  return state
}
